import React, { useState } from 'react';
import ContentLayout from '../../core/ContentLayout';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import PrometTabs from '../../shared/PrometTabs';
import I18n from '../../../blocks/localization';
import MyProfileTab from './tabs/MyProfileTab';
import PersonalDataTab from './tabs/PersonalDataTab';
import ChangePasswordTab from './tabs/ChangePasswordTab';

enum Tab {
    MyProfile = 1,
    PersonalData = 2,
    ChangePassword = 3
}

const MyProfile = () => {
    const [activeTab, setActiveTab] = useState<number>(Tab.MyProfile);

    const clientId = useSelector((state: ApplicationState) => state.account.account?.clientId);

    const onTabClicked = (tab: number) => {
        setActiveTab(tab);
    }

    return (
        <ContentLayout titleTranslateId='myProfile.title'>

            <PrometTabs
                activeTab={activeTab}
                onTabClicked={onTabClicked}
                tabs={
                    [
                        {
                            id: Tab.MyProfile,
                            title: I18n.t('myProfile.tabs.myProfile.title'),
                            content: <MyProfileTab />
                        },
                        {
                            id: Tab.PersonalData,
                            title: I18n.t('myProfile.tabs.personalData.title'),
                            content: <PersonalDataTab />,
                            visible: !!clientId
                        },
                        {
                            id: Tab.ChangePassword,
                            title: I18n.t('myProfile.tabs.changePassword.title'),
                            content: <ChangePasswordTab />
                        }
                    ]
                }
            />

        </ContentLayout>
    );
};

export default MyProfile;
